import React from "react"
import menu from "../data/menu.json"
import { withPrefix } from "gatsby"

export default function DownloadFullReport({ location, title }) {
  const downloads = menu.find(item => {
    return item.name === "Downloads"
  }).children
  const downloadLink = downloads.find(item => {
    return item.name === "Download Full Report"
  })
  const reports = downloads.find(item => {
    return item.name === "Download Full Report"
  }).children

  return reports ? (
    <div
      className={
        location
          ? `download-full-report download-full-report--${location}`
          : "download-full-report"
      }
    >
      <h4 className="title--s">{title ? title : "Download the PDF Report"}</h4>
      <ul>
        {reports.map((item, index) => (
          <li key={index} lang={item.lang}>
            <a href={withPrefix("/") + item.href}>{item.name}</a>
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <a href={withPrefix("/") + downloadLink.href} className="title--s">
      {downloadLink.name}
    </a>
  )
}
